import { SearchType } from '@aibees/elephant/types';
import { TransferListGroupItems } from '@aibees/shared/features';
import { useMemo } from 'react';

export const useTableLayoutConfig = (type: SearchType | undefined) => {
  const groupedItems: TransferListGroupItems[] = useMemo(
    () =>
      type === SearchType.People
        ? [
            {
              label: SearchType.People,
              icon: 'people-outline',
              groupColor: 'success.600',
            },
            {
              label: SearchType.Company,
              icon: 'business',
              groupColor: 'primary.500',
            },
          ]
        : [
            {
              label: SearchType.Company,
              icon: 'business',
              groupColor: 'primary.500',
            },
          ],
    [type]
  );

  const label = useMemo(
    () => (type === SearchType.People ? 'People' : 'Company'),
    [type]
  );

  return { groupedItems, label };
};
